import React from "react";
import { Container } from "reactstrap";
import PlatformSidebar from "./PlatformSidebar";
import PlatformHeader from "./PlatformHeader";
import "./PlatformSidebar.css";

/**
 * PlatformLayout — Layout dedicado para o Painel Administrativo Global.
 *
 * Visualmente distinto do layout de tenant:
 * - Sidebar escura (azul-marinho/dark)
 * - Header simplificado com badge super_admin
 * - Sem dependência de LayoutContext do tenant
 */
const PlatformLayout = ({ children }) => {
    return (
        <div id="platform-layout-wrapper">
            <PlatformHeader />
            <PlatformSidebar />
            <div className="platform-main-content">
                <div className="platform-page-content">
                    <Container fluid>
                        {children}
                    </Container>
                </div>
            </div>
        </div>
    );
};

export default PlatformLayout;
